// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"492e6b75","607":"0f7e4fc9","977":"042c8deb"}[chunkId] + ".chunk.js";
};